import {
  CardWrapper,
  Wrapper,
  Card,
  CardMedia,
  CardTitle,
  StyledLink,
} from './styles';

import { useAuth } from '../../../../context/auth';

const cardData = [
  {
    to: '/alpr/blob-settings',
    img: 'BlobSettingsIcon',
    title: 'Blob Settings',
    testId: 'blob-settings-link'
  }
];

export default function AlprHome() {
  const { state: { user } } = useAuth();

  return (
    <Wrapper className="blob-settings-home" data-test="blob-settings-home">
      {cardData.map((card, index) => (
        <CardWrapper className="card-wrapper" key={index}>
          <Card>
            <StyledLink to={card.to} data-test={card.testId}>
              <CardMedia img={card.img}></CardMedia>
              <CardTitle className="card-title">{card.title}</CardTitle>
            </StyledLink>
          </Card>
        </CardWrapper>
      ))}
    </Wrapper>
  );
}
